// extracted by mini-css-extract-plugin
export default {"flexRow":"Main_flexRow__edGqt","wrapper":"Main_wrapper__WYONY"};